import { render, staticRenderFns } from "./MasterMenuSubMenu.vue?vue&type=template&id=91e12a22&"
import script from "./MasterMenuSubMenu.vue?vue&type=script&lang=js&"
export * from "./MasterMenuSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./MasterMenuSubMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports